import {OfferType} from '@/components/charts/salesHorizon';

/**
 * The chart of the sales of similar estates nearby as PHP prepares it (NearbySalesChartData): the same numbers as the
 * picture of the documents, the chart only draws them.
 */
export interface NearbySaleMode {
    days: string;
    share: number;
    note: string;
}

export interface NearbySalesPeriod {
    label: string;
    name: string;
    sales: number[];
    total: number;
}

export interface NearbySalesChartData {
    saleModes: NearbySaleMode[];
    periods: NearbySalesPeriod[];
    total: number;
    totalLabel: string;
    offerType: OfferType;
    range: string;
    average: number;
    averageNote: string;
}

// From the quickest sale mode to the slowest one
const TONES = ['#1d4f91', '#509bfe', '#9cc4f7', '#cfe2fb'];

export const NEARBY_SALES_COLORS = {
    average: '#e26e2c',
    grid: 'rgba(0, 0, 0, 0.06)',
    muted: '#6c757d',
    ink: '#212529',
};

export function toneOf(saleMode: number): string {
    return TONES[Math.min(saleMode, TONES.length - 1)];
}

// The intervals of the axis of sales of the picture of the documents (GdNearbySalesChartRenderer)
const MAXIMUM_INTERVALS = 4;

/** The axis of sales as the picture of the documents counts it: a step of 1, 2 or 5 times a power of ten */
export function salesAxis(chart: NearbySalesChartData): {max: number; step: number} {
    const highest = Math.max(...chart.periods.map(period => period.total));

    for (let magnitude = 1; ; magnitude *= 10) {
        for (const step of [1, 2, 5]) {
            if (highest / (step * magnitude) <= MAXIMUM_INTERVALS) {
                return {max: Math.ceil(highest / (step * magnitude)) * step * magnitude, step: step * magnitude};
            }
        }
    }
}
